import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddService extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        ServiceId: '',
        serviceGroupId: '',
        account: '',
        ServiceGroup: '',
        ServiceCode: '',
        ServiceDescription: '',
        UnitCharge: '',
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        let type = this.props.match.params.type;
        this.setState({ type: type });

        this.props.getMasterKeywordList("Accounts");
        this.props.getMasterKeywordList("ServiceGroup");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetTbsServicebyid?ServiceId=${id}`, this.state.CompanyId

            );
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.tableLists !== prevProps.tableLists) {
            console.log("tableLists =", this.props.tableLists);

            const Service = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!Service) return;

            // this.setState({
            //     CompanyId: Service.Companyid,
            //     // ServiceId: Service.serviceId || Service.ServiceId || "",
            //     serviceGroupId: Service.servicegroupId || "",
            //     ServiceGroup: Service.servicegroup || "",
            //     ServiceCode: Service.serviceCode || "",
            //     ServiceDescription: Service.serviceDescription || "",
            //     // ServiceType: Service.serviceType || "",
            //     // ChargeType: Service.chargeType || "",
            //     UnitCharge: Service.unitcharge || "",


            // });
            this.setState({
                CompanyId: Service.Companyid,
                ServiceId: Service.serviceId || Service.ServiceId || "",
                serviceGroupId: Service.servicegroupId || "",
                ServiceGroup: Service.servicegroup || "",
                ServiceCode: Service.serviceCode || "",
                ServiceDescription: Service.serviceDescription || "",
                // account: String(Service.account ?? Service.Account ?? ""),
                account:Service.glaccount,
                UnitCharge: Service.unitcharge || "",
            });
        }
    }


    //             axios.get('/master/api/DropDownValues/FRole')
    //                 .then(response => {
    //         if (response.status === 200) {
    //     let data = []
    //     if (response.data && response.data.length > 0) {
    //         data = response.data.map(list => {
    //             let value = list.id;
    //             let id = list.id;
    //             let text = list.text
    //             return { label: text, value: value.toString(), id: id };
    //         })
    //     }
    //     this.setState({ functionalRoleOptions: data })
    // }
    //                 }
    //                 )
    //                 .catch (err => {
    //     this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
    // })

    // if (type !== 'add') {
    //     this.timer();
    // }
    //         }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }
    // componentWillUnmount() {
    //     if (this.props.tableLists.usersList !== undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    // fetchSingleProcess = () => {

    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists.usersList !== undefined) {
    //         storageItems = this.props.tableLists.users;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             let roles = '';
    //             let functionalRoles = '';
    //             let approvalroles = '';
    //             if (filterData.roleAssigned != null) {
    //                 roles = filterData.roleAssigned.split(",")
    //             }
    //             if (filterData.functionalRole != null) {
    //                 functionalRoles = filterData.functionalRole.split(",")
    //             }
    //             if (filterData.approvalrole != null) {
    //                 approvalroles = filterData.approvalrole.split(",")
    //             }
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 UserId: filterData.userId,
    //                 EmployeeId: filterData.employeeId,
    //                 RoleId: roles,
    //                 approvalRoleId: approvalroles,
    //                 UserId1: filterData.userid1,
    //                 FirstName: filterData.firstName,
    //                 functionalRoleId: functionalRoles,
    //                 MiddleName: filterData.middleName,
    //                 LastName: filterData.lastName,
    //                 EmailId: filterData.emailId,
    //                 Password: filterData.password,
    //                 MobileNumber: filterData.mobileNumber,
    //                 Activedirectory: filterData.activedirectory,
    //                 Adloginid: filterData.adloginid,
    //                 Disablelogin: filterData.disablelogin,
    //                 IsActive: filterData.isActive,
    //                 CreatedBy: filterData.createdby,
    //                 CreatedDate: filterData.createddate,
    //             }
    //             this.setState(data);

    //         }
    //     }

    // }


    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        const { name } = e.target;

        this.setState({
            [name]: e.value,
            touch: true
        });
    };
    // onDropdownChange = (e) => {
    //     this.setState({
    //         [e.target.name]: e.value,
    //         touch: true
    //     });
    // }

    add = () => {

        // if (this.state.EmployeeId === null) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
        //     return;
        // } else if (this.state.RoleId === null || this.state.RoleId === '') {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
        //     return;
        // }

        // else if (this.state.UserId1 === "") {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
        //     return;
        // } else if (this.state.FirstName === "") {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
        //     return;
        // } else if (this.state.LastName === "") {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
        //     return;
        // } else if (this.state.EmailId === "" || this.state.EmailId === null) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
        //     return;
        // } else if (this.state.Password === "") {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
        //     return;
        // } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
        //     return;
        // } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
        //     return;
        // } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
        //     return;
        // }

        var data = {
            servicegroupId: this.state.serviceGroupId,
            servicegroup: this.state.ServiceGroup,
            serviceCode: this.state.ServiceCode,
            serviceDescription: this.state.ServiceDescription,
            glaccount: this.state.account,
            unitcharge: this.state.UnitCharge,
        };


        if (this.state.type === 'edit') {
            data.serviceId = this.state.ServiceId;

        }
        this.props.processDynamicData('tbsservice', this.state.type, data, 'res/GetTbsServicebyid?' + Companyid);


    }

    resetData = () => {
        var data = {
            //    roles: [],
            type: 'add',
            // Id: null,
            ServiceId: '',
            serviceGroupId: '',
            ServiceGroup: '',
            ServiceCode: '',
            ServiceDescription: '',
            // ServiceType: '',
            // ChargeType: '',
            UnitCharge: '',
            // CompanyId: this.props.loggedUserDetail.CompanyId,
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/service/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/service/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }

        // let serviceGroupOptions = [];

        // if (this.props.ServiceGroup && this.props.ServiceGroup.length > 0) {
        //     serviceGroupOptions = this.props.ServiceGroup.map(item => ({
        //         label: item.label || item.text || item.name,
        //         value: item.value || item.id
        //     }));
        // }

        //         let serviceGroupOptions = [];

        // if (this.props.ServiceGroup && this.props.ServiceGroup.length > 0) {
        //     serviceGroupOptions = this.props.ServiceGroup.map(item => ({
        //         label: item.label || item.text || item.name,
        //         value: item.value
        //     }));
        // }

        let serviceGroupOptions = [];

        if (this.props.ServiceGroup && this.props.ServiceGroup.length > 0) {

            console.log("SERVICE GROUP API DATA:", this.props.ServiceGroup);

            serviceGroupOptions = this.props.ServiceGroup.map(item => {

                console.log("SERVICE GROUP ITEM:", item);

                return {
                    label: item.label || item.text || item.name,
                    value: item.value
                };
            });
        }

        let accountOptions = [];

        if (this.props.Accounts && this.props.Accounts.length > 0) {
            accountOptions = this.props.Accounts.map(item => ({
                label: item.label || item.text || item.name,
                value: String(item.value ?? item.id ?? "")
            }));
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Service</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Service Group <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Service Group" options={serviceGroupOptions} value={this.state.serviceGroupId} name="serviceGroupId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="ServiceCode" placeholder="Code" value={this.state.ServiceCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Service Description <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="ServiceDescription" placeholder="Service Description" value={this.state.ServiceDescription} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Service Type <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Service Type" options={this.props.GetEmployeedropdown} value={this.state.ServiceType} name="ServiceType" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} />
                                </div> */}

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">GL Account <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="GL Account" options={accountOptions} value={this.state.account} name="account" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Charge Type <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Charge Type" options={this.props.GetEmployeedropdown} value={this.state.UnitCharge} name="UnitCharge" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} />
                                </div> */}

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Unit Price <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="UnitCharge" placeholder="Unit Price" value={this.state.UnitCharge} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>






                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div> */}
                            </div>
                            <div className="p-col-12 p-lg-12">

                                {/* <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} /> */}

                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/service/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        Accounts: (state.keyword.Accounts !== undefined) ? state.keyword.Accounts : [],
        ServiceGroup: (state.keyword.ServiceGroup !== undefined) ? state.keyword.ServiceGroup : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddService);